import { useTranslation } from "next-i18next";
import HeadMetaContainer from "../common/HeadMetaContainer";
import useWxShare from "@/hooks/useWxShare";
import { useEffect, useState } from "react";
import { isInApp } from "@/utils/util";
import clsx from "clsx";

interface Props {
  children: React.ReactNode;
}

export default function CopilotContainer({ children }: Props) {
  const { t } = useTranslation("copilot");
  const [inApp, setInApp] = useState(false);
  useEffect(() => {
    const _inApp = isInApp();
    if (!_inApp) {
      document.body.style.paddingBottom = "0px";
    }
    setInApp(isInApp());
  }, []);
  useWxShare(undefined, undefined, {
    title: t("SHARE_TITLE"),
    desc: t("SHARE_DESC"),
    imgUrl: `${process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND}/h5/copilot/rock-bot.png`,
  });
  return (
    <HeadMetaContainer
      title={t("SHARE_TITLE")}
      description={t("SHARE_DESC")}
      imageUrl={`${process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND}/h5/copilot/rock-bot.png`}
    >
      <>
        <div
          className={clsx(
            'bg-white" w-full overflow-hidden',
            inApp ? "self-bar-wrapper" : "h-full"
          )}
        >
          {children}
        </div>

        <style jsx global>{`
          body {
            padding-top: 0;
          }
        `}</style>
      </>
    </HeadMetaContainer>
  );
}
